import { useMemo } from 'react';

import { BootstrapVerticalColumnTable } from '@components/Table/Table';
import { DOCUMENTS_TO_HIDE } from '@config/const';

function renderDocumentCell({ value, required }) {
  if (!value && !required) {
    return <span className="opacity-50">Optional</span>;
  }
  if (!value && required) {
    return <span className="textRed">Missing</span>;
  }
  const { document_filename: filename } = value;
  if (value && required) {
    return <span className="textGreen">{filename}</span>;
  }
  if (value && !required) {
    return <span className="opacity-50">{filename} (Optional)</span>;
  }
  return null;
}

function renderFieldCell({ value, required }) {
  if (!value && !required) {
    return <span className="opacity-50">Optional</span>;
  }
  if (!value && required) {
    return <span className="textRed">Missing</span>;
  }

  if (value && required) {
    return <span className="textGreen">{value}</span>;
  }
  if (value && !required) {
    return <span className="opacity-50">{value} (Optional)</span>;
  }
  return null;
}

export const ProfileDataTable = ({ data }) => {
  const createColumn = (field) => ({
    id: field.field,
    Header: field.label,
    accessor: field.field,
    className: 'col-md-1 fw-normal',
    Cell: ({ value }) => renderFieldCell({ value, required: field.required }),
  });

  const values = {};
  data.forEach(({ field, value }) => {
    values[field] = value;
  });

  const columns = useMemo(
    () => [...data.map((item) => createColumn(item))],
    []
  );
  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={[values]}
      tableProps={() => ({ responsive: true, bordered: true })}
    />
  );
};

export const ProfileDocumentsTable = ({ data }) => {
  const createColumn = (document) => ({
    id: document.id,
    Header: document.label,
    accessor: `${document.id}`,
    className: 'col-md-1 fw-normal',
    Cell: ({ value }) =>
      renderDocumentCell({ value, required: document.required }),
  });

  const values = {};
  data.forEach(({ id, value }) => {
    values[id] = value;
  });
  const columns = useMemo(
    () => [
      {
        Header: 'Document',
        className: 'col-md-1 fw-bold',
        Cell: () => 'Status',
      },
      ...data
        .filter(({ id }) => !DOCUMENTS_TO_HIDE.includes(id))
        .map((item) => createColumn(item)),
    ],
    []
  );
  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={[values]}
      tableProps={() => ({ responsive: true, bordered: true })}
    />
  );
};
